import { connect } from 'react-redux';

import Actions from '../../Actions/Creators';
import Content from './Component/Content';


const mapStateToProps = (state, ownProps) => ({

});


const mapDispatchToProps = (dispatch) => ({
  
});


export default connect(mapStateToProps, mapDispatchToProps)(Content)